import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";
import { MODIFIED_BY_FILTER_KEY, OWNER_FILTER_KEY, STATUS_FILTER_KEY } from "../const/const";
import type { TActiveFilters, TPortfolioPrefs } from "./portfolioStorage";

const NON_DIMENSION_FILTER_KEYS = new Set([STATUS_FILTER_KEY, OWNER_FILTER_KEY, MODIFIED_BY_FILTER_KEY]);

export function dimensionIdsFromList(dimensions: TOrganizationProjectDimension[]): Set<string> {
  return new Set(dimensions.map((d) => String(d.id)));
}

export function clampPrefsToDimensionIds(prev: TPortfolioPrefs, dimIds: Set<string>): TPortfolioPrefs | null {
  let sortFieldKey = prev.sortFieldKey;
  if (sortFieldKey.startsWith("dim:")) {
    const id = sortFieldKey.slice(4);
    if (!dimIds.has(id)) sortFieldKey = "none";
  } else if (!["none", "name", "createdBy", "modifiedBy", "lastModified", "status"].includes(sortFieldKey)) {
    sortFieldKey = "none";
  }
  const hiddenDimensionIds = prev.hiddenDimensionIds.filter((id) => dimIds.has(id));
  const savedFilters = { ...prev.savedFilters };
  for (const k of Object.keys(savedFilters)) {
    if (!NON_DIMENSION_FILTER_KEYS.has(k) && !dimIds.has(k)) delete savedFilters[k];
  }
  const changed =
    sortFieldKey !== prev.sortFieldKey ||
    hiddenDimensionIds.length !== prev.hiddenDimensionIds.length ||
    JSON.stringify(savedFilters) !== JSON.stringify(prev.savedFilters);
  if (!changed) return null;
  return { ...prev, sortFieldKey, hiddenDimensionIds, savedFilters };
}

export function clampFiltersToDimensionIds(prev: TActiveFilters, dimIds: Set<string>): TActiveFilters | null {
  const next = { ...prev };
  let changed = false;
  for (const k of Object.keys(next)) {
    if (!NON_DIMENSION_FILTER_KEYS.has(k) && !dimIds.has(k)) {
      delete next[k];
      changed = true;
    }
  }
  return changed ? next : null;
}
